export const toggleMessageOpen = (message, messageType) => ({
    type: "TOGGLE_MESSAGE_OPEN",
    message,
    messageType
});
  
export const toggleMessageClose = () => ({
    type: "TOGGLE_MESSAGE_CLOSE",
});